import { api } from './config';
import {
  ApiResponse,
  Project,
  ProjectCreateRequest,
  ProjectUpdateRequest,
  ProjectMoveRequest
} from '../types';

export const projectsApi = {
  getAll: () => api.get<ApiResponse<Project[]>>('/projects'),

  getTree: () => api.get<ApiResponse<Project[]>>('/projects/tree'),

  getById: (id: number) => api.get<ApiResponse<Project>>(`/projects/${id}`),

  /**
   * Check if a project with the given name already exists
   * Returns the existing project if found, null otherwise
   */
  checkByName: (name: string) =>
    api.get<ApiResponse<Project | null>>(`/projects/check?name=${encodeURIComponent(name)}`),

  create: (data: ProjectCreateRequest) =>
    api.post<ApiResponse<Project>>('/projects', data),

  update: (id: number, data: ProjectUpdateRequest) =>
    api.put<ApiResponse<Project>>(`/projects/${id}`, data),

  delete: (id: number) => api.delete<ApiResponse>(`/projects/${id}`),

  move: (data: ProjectMoveRequest) =>
    api.patch<ApiResponse<Project>>('/projects/move', data),

  /**
   * 여러 프로젝트를 하나로 병합 (source 들의 샘플요청을 target 으로 이동 후 원본 삭제)
   * target 은 기존(target_project_id) 또는 신규(new_project_name) 중 하나
   */
  merge: (data: { source_project_ids: number[]; target_project_id?: number; new_project_name?: string }) =>
    api.patch<ApiResponse<Record<string, unknown>>>('/projects/merge', data),

  reorder: (orderedIds: number[]) =>
    api.patch<ApiResponse>('/projects/reorder', { orderedIds }),

  archive: (id: number) =>
    api.patch<ApiResponse<Project>>(`/projects/${id}/archive`),

  restore: (id: number) =>
    api.patch<ApiResponse<Project>>(`/projects/${id}/restore`),

  complete: (id: number) =>
    api.patch<ApiResponse<Project>>(`/projects/${id}/complete`),

  exportToXlsx: (id: number, ids?: number[]) =>
    api.get(`/projects/${id}/export/xlsx${ids && ids.length ? `?ids=${ids.join(',')}` : ''}`, { responseType: 'blob' }),
};
